import { DuckCard } from "../DuckCard";
import { DuckRow } from "./DuckRow";
import { CoverButton } from "./CoverButton";

const branchNote = (g, j) => {
  const n = g.members.length - 1;
  if (j) return `Branch · v${g.members[j].version} of ${g.members[0].name || "the original"}`;
  return n ? `Original · ${n} branch${n === 1 ? "" : "es"}` : null;
};

// Grid: every duck as a card, a family's branches right after their original.
export const FamilyGrid = ({ families, ctx, sectionKey }) => {
  let n = 0;
  return (
    <div data-testid={`flock-grid-${sectionKey}`} className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {families.flatMap((g) =>
        g.members.map((c, j) => {
          const i = `${sectionKey}-${n++}`;
          const extra = <CoverButton c={c} ctx={ctx} compact testId={`gallery-cover-btn-${i}`} />;
          return <DuckCard key={c.id} c={c} i={i} size="lg" actions={ctx.actions} note={branchNote(g, j)} extra={extra} highlight={ctx.q} select={{ checked: ctx.selected.has(c.id), onChange: () => ctx.toggle(c) }} />;
        }),
      )}
    </div>
  );
};

// List: one row per duck, branches indented under their original.
export const FamilyList = ({ families, ctx, sectionKey }) => {
  let n = 0;
  return (
    <ul data-testid={`flock-list-${sectionKey}`} className="mt-4 grid grid-cols-1 gap-2">
      {families.flatMap((g) => g.members.map((c, j) => <DuckRow key={c.id} c={c} rowId={`${sectionKey}-${n++}`} branch={j > 0} ctx={ctx} />))}
    </ul>
  );
};
